import React from "react";
import { Modal, Form, Input, message, Button, InputNumber } from "antd";
import { useAsync } from "../../../../utils/use-async";
import { client } from "../../../../utils/api-client";
import { Spinner } from "../../../lib";

const AddSubject = ({
  modal,
  fetchProject,
  handleCancel,
  setModal,
  project,
}) => {
  const { isLoading, run, isError, error } = useAsync();

  const addSubject = (values) => {
    run(
      client(`project/${project}/subject/add`, {
        body: values,
        method: "PUT",
      }).then((res) => {
        message.success(res.message);
        setModal(false);
        fetchProject(project);
      })
    );
  };

  return (
    <Modal title="Add Subject" visible={modal} onCancel={handleCancel}>
      <Form
        size="middle"
        layout="horizontal"
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={addSubject}
      >
        <Form.Item
          label="Subject"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter subject name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16 } }}>
          <Button type="primary" htmlType="submit">
            Submit{" "}
            {isLoading && (
              <span style={{ marginLeft: "5px", verticalAlign: "middle" }}>
                <Spinner />
              </span>
            )}
          </Button>
        </Form.Item>
        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default AddSubject;
